import { Fragment } from 'react';

import { useComponents } from '#src/lib/component-mappings/index.js';

import Loading from '../Loading';
import {
  selectFields,
  selectFieldsByKey,
  selectContentType,
  selectEntryId,
} from '../../lib/contentful/selectors';
import { useABTest } from '../../hooks';
import ContentRow from '../ContentRow';

import styles from './styles.module.scss';

const isExperiment = (content) =>
  content?.sys?.contentType?.sys?.id === 'hubExperiment';

const selectRowContent = (row, activate, getTest, currentTheme) => {
  if (!isExperiment(row)) return row;

  const { altExperimentId, googleOptimizeExperimentId, theme, variants } =
    selectFields(row);

  const defaultVariant = variants[0];
  if (theme != currentTheme) return defaultVariant;

  const experimentState = getTest(googleOptimizeExperimentId);
  const variant = experimentState?.variant;
  if (!experimentState) {
    activate({ altExperimentId, experimentId: googleOptimizeExperimentId });
  }
  return variants[variant] || defaultVariant;
};

const DynamicPage = ({ content, theme, loading }) => {
  const { activate, getTest } = useABTest();
  const {
    contentRowsWrapper: WrapperCmp = Fragment,
    contentRow: ContentRowCmp = ContentRow,
  } = useComponents();

  return (
    <main className={styles.container} role="main">
      {loading && <Loading />}
      {!loading && (
        <WrapperCmp>
          {!!content?.hero && (
            <ContentRowCmp
              theme={theme}
              contentTypeId={selectContentType(content.hero)}
              componentNamespace={content?.componentNamespace}
              {...selectFieldsByKey('hero')(content)}
            />
          )}
          {content?.rows?.map((origRow, index) => {
            const row = selectRowContent(origRow, activate, getTest, theme);
            const entryId = selectEntryId(row);
            return (
              <ContentRowCmp
                key={`${selectContentType(row)}-${entryId}-${index}`}
                contentTypeId={selectContentType(row)}
                componentNamespace={content?.componentNamespace}
                entryId={entryId}
                theme={theme}
                {...selectFields(row)}
              />
            );
          })}
        </WrapperCmp>
      )}
    </main>
  );
};

export default DynamicPage;
